import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function ImageUpload({ value, onChange, label, testid, aspect = "aspect-video" }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${BACKEND_URL}${data.url}`);
      toast.success("Image uploaded");
    } catch (err) { toast.error(apiErr(err)); }
    setLoading(false);
    e.target.value = "";
  };

  return (
    <div className="space-y-1.5">
      {label && <p className="text-sm font-medium">{label}</p>}
      <div className={`relative ${aspect} w-full rounded-lg border border-dashed border-border overflow-hidden bg-muted/40 group`}>
        {value ? (
          <>
            <img src={value} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => onChange("")} data-testid={`${testid}-remove`}
              className="absolute top-2 right-2 h-7 w-7 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80">
              <X className="h-4 w-4" />
            </button>
            <button type="button" onClick={() => inputRef.current?.click()}
              className="absolute bottom-2 right-2 text-xs bg-black/60 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
              Replace
            </button>
          </>
        ) : (
          <button type="button" onClick={() => inputRef.current?.click()} data-testid={`${testid}-btn`}
            className="absolute inset-0 flex flex-col items-center justify-center gap-1 text-muted-foreground hover:text-foreground">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Upload className="h-5 w-5" />}
            <span className="text-xs">{loading ? "Uploading..." : "Upload image"}</span>
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handle} data-testid={`${testid}-input`} />
    </div>
  );
}
